module.exports = __webpack_public_path__ + "img/tafel.a4c0ce88.png";